import { NavLink } from "react-router";

import Time from "common/Time";
import { UploadedDocument } from "models/dashboard/dashboard";

import "./UploadedDocumentsPreviewItem.scss";

type Props = {
  link: string;
  document: UploadedDocument;
};

export default function UploadedDocumentsPreviewItem({
  link,
  document
}: Props) {
  const createCategory = (category: string) => {
    if (category === "Okategoriserad") {
      return "";
    } else {
      return " med kategori " + category;
    }
  };

  const commentPreview = document.comment && document.comment.length > 0 && (
    <div className="comment">{document.comment}</div>
  );

  return (
    <li className="uploadedDoc">
      <NavLink title="Gå till inleveranser" to={link}>
        <div className="body">
          <div>
            <strong>{document.fileName}</strong>&nbsp;laddades upp&nbsp;
            {createCategory(document.category)}
            {commentPreview}
          </div>
          <time>{Time.formatShort(document.createdAt)}</time>
        </div>
      </NavLink>
    </li>
  );
}
